<template>
    <section class="tab-card-section">
        <div class="title-with-line">
            {{ props.item.mainTitle }}
        </div>
    </section>
</template>

<script setup lang="ts">
import type { Module } from '@/api/page_config'

const props = defineProps<{
    item: Module
}>()


</script>

<style scoped lang="scss">
@use '@/assets/styles/variables' as *;

.tab-card-section {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.title-with-line {
    font-size: 1.75rem;
    font-weight: 800;
    color: $color-text;
    margin: 0 0 0.8rem;
    padding-bottom: 0.5rem;
    text-align: center;
    position: relative;

    @media (min-width: $breakpoint-md) {
        font-size: 2.25rem;
        margin-bottom: 0.75rem;
    }

    &::after {
        content: ' ';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 60%;
        height: 0.3rem;
        transform: translateX(-50%);
        border-radius: 0.3rem;
        background: linear-gradient(270deg, #fc821d 8%, #fb6a13 83%);
    }
}
</style>
